import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { getSubdomainHelper } from 'src/helpers/getSubdomainHelper';
import { FRESHDESK_URL } from 'src/constants/urls';

export const EditFreshdeskEmailApiDetailsSettings = ({ integration }) => {
  const { control } = useFormContext();
  return (
    <div className={'w-full flex flex-col gap-2.5 p-2.5 bg-[#A498FF1A] rounded-sm-5'}>
      <div>
        <Controller
          control={control}
          name="subdomain"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'Freshdesk subdomain*'}
              placeholder={'domain.com'}
              className={'!py-2.5 !px-3.5'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={(e) => {
                const res = getSubdomainHelper(e.target.value);
                if (res?.subdomain) {
                  onChange(res?.subdomain);
                } else {
                  onChange(e.target.value);
                }
              }}
              infoTooltip={{
                side: 'right',
                description: 'Link to your Freshdesk workspace.',
              }}
            />
          )}
        />
      </div>
      <div>
        <Controller
          control={control}
          name="api_key"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Input
              type={'text'}
              label={'API key'}
              placeholder={'Yb2KQfS8VQj1HxZlOzVbXk4P6W1Cm3aA1dFxGnYq'}
              invalidMessage={error?.message}
              value={value}
              isValid={!error?.message}
              onChange={onChange}
              infoTooltip={{
                side: 'right',
                description: (
                  <p>
                    Check how to find the API Key{' '}
                    <a
                      className={'underline'}
                      href={FRESHDESK_URL.WHERE_CAN_FIND_API_KEY}
                      target={'_blank'}
                      rel={'nofollow noreferrer'}
                    >
                      here →
                    </a>
                  </p>
                ),
              }}
            />
          )}
        />
      </div>
    </div>
  );
};
